import React, { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import Currency from 'components/currency';
import { ILoyaltyCardTransaction } from 'state/loyalty/types';

import { DateAndTimeCell } from './datetime-cell';
import { PurchaseAmount, Reward, Rewards } from './transaction.styled';

export const useLocalizedTransactionTransformer = () => {
  const { formatMessage } = useIntl();

  const transactionTransformer = useCallback(
    (loyaltyCardTransaction: ILoyaltyCardTransaction) => {
      const {
        bonusPoints,
        timestamp: timeStamp,
        basketTotal,
        discountAmount = 0,
        pointsEarned,
        isCustomerServiceVisit,
        pointsUsed,
        tag,
      } = loyaltyCardTransaction;

      const purchaseAmount = (
        <PurchaseAmount>
          <Currency amount={basketTotal - discountAmount} />
        </PurchaseAmount>
      );

      const rewards = (
        <Rewards>
          {bonusPoints && <Reward>{`+${bonusPoints} ${formatMessage({ id: 'bonus' })}!`}</Reward>}
          {pointsEarned && <Reward>{`+${pointsEarned}pts`}</Reward>}
          {pointsUsed && <Reward>{`-${pointsUsed}pts`}</Reward>}
          {isCustomerServiceVisit && <Reward>{`${formatMessage({ id: 'serviceVisit' })}!`}</Reward>}
          {messages[tag] && <Reward>{`${formatMessage(messages[tag])}`}</Reward>}
        </Rewards>
      );

      const dateTime = <DateAndTimeCell timeStamp={timeStamp} />;

      return { timeStamp, dateTime, rewards, purchaseAmount };
    },
    [formatMessage]
  );

  return transactionTransformer;
};
const messages = defineMessages({
  CHALLENGE_COMPLETE: {
    id: 'challengeComplete',
    defaultMessage: 'Challenge Completed',
    description: 'Text for generic formation offer completed',
  },
  DAYPART_CHALLENGED_COMPLETED: {
    id: 'daypartChallengedCompleted',
    defaultMessage: 'Challenge Completed',
    description: 'Text for daypart formation offer completed',
  },
  FREQUENCY_CHALLENGED_COMPLETED: {
    id: 'frequencyChallengedCompleted',
    defaultMessage: 'Challenge Completed',
    description: 'Text for frequency formation offer completed',
  },
  PRODUCT_CHALLENGED_COMPLETED: {
    id: 'productChallengedCompleted',
    defaultMessage: 'Challenge Completed',
    description: 'Text for product formation offer completed',
  },

  HOCKEY_1: {
    id: 'hockey1',
    defaultMessage: 'Hockey - 1 Pick',
    description: 'Hockey 1 pick default message',
  },
  HOCKEY_2: {
    id: 'hockey2',
    defaultMessage: 'Hockey - 2 Picks',
    description: 'Hockey 2 pick default message',
  },
  HOCKEY_3: {
    id: 'hockey3',
    defaultMessage: 'Hockey - 3 Picks',
    description: 'Hockey 3 pick default message',
  },

  offerApplied: {
    id: 'offerApplied',
    defaultMessage: 'Offer applied',
    description: 'Offer applied text',
  },
});
